<template>
  <el-form class="check-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="defaultVal">
      <template slot="label">
        默认值
      </template>
      <el-select v-model="control.defaultVal.value" placeholder="请选择">
        <el-option
          v-for="item in checkStates"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import { checkStates } from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"

export default {
  name: "check-control",
  props: {
    control: Object
  },
  data() {
    return {
      checkStates
    }
  }
}
</script>

<style lang="scss" scoped>
.check-control {
  .el-select {
    width: 100%;
  }
}
</style>
